import { KioskProvider } from './KioskContext';

/**
 * A casca dos TERMINAIS de chão (/coletor e /bancada): tela limpa, sem
 * sidebar, sem navbar, sem navegação nenhuma — o operador não "usa o sistema",
 * ele opera um posto. O dispositivo fica logado com a conta de terminal; quem
 * age é o CRACHÁ bipado (CollectorEmployeeContext), e no quiosque o crachá é
 * SÓ-LEITOR (ver CollectorBadgeIdentify + useKiosk).
 */
const KioskShell = ({ children }) => (
    <KioskProvider>
        <div className="min-h-dvh bg-mono-50 dark:bg-mono-950">
            <main className="mx-auto min-h-dvh w-full px-3 py-4">{children}</main>
        </div>
    </KioskProvider>
);

export default KioskShell;
